import axios from 'axios';

const list = (data) => axios.get('/pro/orderLine/list', data);
const save = (data) => axios.post('/pro/orderLine/save', data);
const del = (data) => axios.post('/pro/orderLine/delete', data);


export default {
  list,
  save,
  del,

}


